import 'choerodon-ui/lib/style/index.less';
import './index.less';
// style dependencies
import 'choerodon-ui/lib/menu/style';
import 'choerodon-ui/lib/checkbox/style';
import '../../check-box/style';
import '../../text-field/style';
import '../../button/style';
